import createClient, { type Middleware } from "openapi-fetch";
import type { paths } from "./schema";

// Typovaný klient z OpenAPI backendu (R-02). schema.d.ts se generuje příkazem `npm run gen:api`.

// R-10: mutační požadavky musí nést hlavičku X-Requested-With (ochrana proti CSRF spolu se SameSite cookie).
const requestedWith: Middleware = {
  onRequest({ request }) {
    request.headers.set("X-Requested-With", "XMLHttpRequest");
    return request;
  },
};

export const api = createClient<paths>({ baseUrl: "/", credentials: "same-origin" });
api.use(requestedWith);

/** Chyba API ve tvaru ProblemDetails; `code` je klíč textu chyby `error.{code}` (R-16). */
export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string | undefined,
    message: string,
    /** Další údaje z ProblemDetails (např. `doneBy`), použijí se jako proměnné v textu chyby. */
    public readonly details: Record<string, unknown> = {},
  ) {
    super(message);
    this.name = "ApiError";
  }
}

type FetchResult<T> = { data?: T; error?: unknown; response: Response };

function toApiError(result: FetchResult<unknown>): ApiError {
  const problem = (result.error ?? {}) as { code?: string; title?: string } & Record<string, unknown>;
  return new ApiError(result.response.status, problem.code, problem.title ?? result.response.statusText, problem);
}

/** Vrátí data odpovědi, nebo vyhodí ApiError (pro použití v TanStack Query). */
export function unwrap<T>(result: FetchResult<T>): T {
  if (result.error !== undefined || result.data === undefined) throw toApiError(result);
  return result.data;
}

/** Pro odpovědi bez těla (204). */
export function unwrapEmpty(result: FetchResult<unknown>): void {
  if (!result.response.ok) throw toApiError(result);
}
